(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-catalog"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.cf-catalog');
  if (!section) return;

  var grid = section.querySelector('#cf-catalog-grid');
  var emptyMsg = section.querySelector('#cf-catalog-empty');
  var pills = section.querySelectorAll('.cf-pill[data-filter]');
  var items = section.querySelectorAll('.cf-grid__item');

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    items.forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  function setupReveal() {
    if (prefersReducedMotion) {
      revealAll();
      return;
    }
    if (!('IntersectionObserver' in window)) {
      revealAll();
      return;
    }
    items.forEach(function (item) {
      item.classList.add('cf-reveal--js');
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function restagger(visibleItems) {
    visibleItems.forEach(function (item, i) {
      item.style.setProperty('--cf-i', i);
      item.classList.remove('is-visible');
    });
    if (prefersReducedMotion) {
      visibleItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }
    setTimeout(function () {
      visibleItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }, 20);
  }

  function applyFilter(filter) {
    var visibleItems = [];
    var typeValue = filter.indexOf('type:') === 0 ? filter.slice(5) : null;
    items.forEach(function (item) {
      var show = false;
      if (filter === 'all') {
        show = true;
      } else if (typeValue !== null) {
        show = (item.getAttribute('data-type') || '').toLowerCase() === typeValue.toLowerCase();
      } else if (filter.indexOf('tag:') === 0) {
        var tag = filter.slice(4);
        var tags = (item.getAttribute('data-tags') || '').split(',');
        show = tags.indexOf(tag) !== -1;
      }
      if (show) {
        item.classList.remove('cf-grid__item--hidden');
        visibleItems.push(item);
      } else {
        item.classList.add('cf-grid__item--hidden');
      }
    });

    if (emptyMsg) {
      if (visibleItems.length === 0) {
        emptyMsg.removeAttribute('hidden');
      } else {
        emptyMsg.setAttribute('hidden', '');
      }
    }

    restagger(visibleItems);
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) {
        p.classList.remove('cf-pill--active');
        p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('cf-pill--active');
      pill.setAttribute('aria-pressed', 'true');
      applyFilter(pill.getAttribute('data-filter') || 'all');
    });
  });

  setupReveal();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGallery(sectionId) {
    var frame = document.querySelector('#cf-gallery-main-' + sectionId + ' .cf-pd-gallery__frame');
    var mainImg = document.getElementById('cf-main-img-' + sectionId);
    var thumbBtns = document.querySelectorAll('[data-thumb-index][data-section="' + sectionId + '"]');

    if (!frame || !thumbBtns.length) return;

    function setActive(index) {
      thumbBtns.forEach(function (btn) {
        var isActive = parseInt(btn.dataset.thumbIndex, 10) === index;
        btn.classList.toggle('cf-pd-thumb--active', isActive);
      });
    }

    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.dataset.thumbIndex, 10);
        var src = btn.dataset.src;
        if (!src || !mainImg) return;
        mainImg.src = src;
        if (btn.dataset.srcset) {
          mainImg.srcset = btn.dataset.srcset;
        } else {
          mainImg.removeAttribute('srcset');
        }
        setActive(index);
      });
    });
  }

  function initQty(sectionId) {
    var dec = document.getElementById('cf-qty-dec-' + sectionId);
    var inc = document.getElementById('cf-qty-inc-' + sectionId);
    var display = document.getElementById('cf-qty-display-' + sectionId);
    var input = document.querySelector('#cf-qty-' + sectionId + '[data-qty-input]');

    if (!dec || !inc || !display || !input) return;

    var qty = 1;

    function update(next) {
      qty = Math.max(1, next);
      display.textContent = qty;
      input.value = qty;
      dec.disabled = qty <= 1;
    }

    dec.addEventListener('click', function () { update(qty - 1); });
    inc.addEventListener('click', function () { update(qty + 1); });
    update(1);
  }

  function initMobileBar(sectionId, formId) {
    var mobileBtn = document.getElementById('cf-mobile-atc-' + sectionId);
    if (!mobileBtn) return;

    mobileBtn.addEventListener('click', function () {
      var form = document.getElementById(formId);
      if (!form) return;
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn && !submitBtn.disabled) {
        submitBtn.click();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-section][data-product-id]');
    sections.forEach(function (el) {
      var id = el.dataset.section;
      if (!id) return;
      initGallery(id);
      initQty(id);
      initMobileBar(id, 'cf-product-form-' + id);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(function () {
  var container = document.getElementById('ProductGridContainer');
  if (!container) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(items) {
    items.forEach(function (item) { item.classList.add('is-visible'); });
  }

  function setupReveal() {
    var items = container.querySelectorAll('.cf-reveal');
    if (!items.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealAll(items);
      return;
    }

    items.forEach(function (item) { item.classList.add('cf-reveal--js'); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (item) { observer.observe(item); });
  }

  setupReveal();

  document.addEventListener('collection:rerendered', function () {
    setupReveal();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
